import { Component, Input } from '@angular/core';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { BaseRules, TextValues } from './wisconsin.model';
import { PipBaseStateComponent } from '../pip-base-state.component';

@Component({
  selector: 'app-wisconsin',
  templateUrl: './wisconsin.component.html',
  styleUrls: ['./wisconsin.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe
  ]
})
export class WisconsinComponent extends PipBaseStateComponent<BaseRules, TextValues> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('wisconsin', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('wisconsin', null);
    }
  }
}
